import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AdvancedLimits } from './../models/index';

@Injectable()
export class AdvancedLimitsService extends BaseApiService implements Resolve<AdvancedLimits> {
  constructor(
    private apiCallService: ApiCallService
  ) {
    super();
  }

  getAdvancedLimits(propertyType: string): Promise<AdvancedLimits> {
    this.validateString(propertyType, 'property_type');
    return this.apiCallService.get('/new_properties/advanced_limits/' + propertyType);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<AdvancedLimits> {
    const promise = this.getAdvancedLimits(route.data['property_type']);
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/advanced-limits.service.ts